import { render, staticRenderFns } from "./EditProductForm.vue?vue&type=template&id=371145b1&"
import script from "./EditProductForm.vue?vue&type=script&lang=js&"
export * from "./EditProductForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports